import { leadPhoneValue } from "./NameWithContactActionsCell"

export function leadContactPayload(lead, leadSource) {
  const source = leadSource || lead?.lead_source || ""
  const refId =
    lead?.lead_ref_id != null && lead.lead_ref_id !== ""
      ? String(lead.lead_ref_id)
      : lead?.id != null
      ? String(lead.id)
      : ""
  return {
    name: lead?.name || "",
    phone: leadPhoneValue(lead),
    email: lead?.email?.trim() || "",
    company_name: lead?.office_name || "",
    lead_source: source,
    lead_ref_id: refId,
  }
}

export function toLeadCallContact(lead, leadSource = "mls") {
  return {
    candidate_name: lead?.name || "",
    company_name: lead?.office_name || "",
    phone: leadPhoneValue(lead),
    email: lead?.email?.trim() || "",
    isLead: true,
    leadSource,
    leadRefId: lead?.id != null ? String(lead.id) : "",
  }
}
